module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/filter-29986953608d4ab7e5cf5d948d397683.svg";